import { FC } from 'react';
import styled from 'styled-components';
import { CircularProgress, IconButton } from '@mui/material';
import Play from '@mui/icons-material/PlayCircle';
import { MediaType } from './MediaCard';

const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

type Props = {
  mediaType: MediaType;
  sending: boolean;
  isMediaLoaded: boolean;
};

export const CenterIcon: FC<Props> = ({
  mediaType,
  sending,
  isMediaLoaded,
}) => {
  if (!isMediaLoaded || sending) {
    return (
      <IconWrapper>
        <CircularProgress />
      </IconWrapper>
    );
  }
  if (mediaType === 'video') {
    return (
      <IconWrapper>
        <IconButton>
          <Play fontSize="large" />
        </IconButton>
      </IconWrapper>
    );
  }
  return null;
};
